// extracted by mini-css-extract-plugin
export default {"subscription":"SubscriptionEntriesWithHeader_subscription__BuRi2"};